var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgThumbsUp = function SvgThumbsUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.063 10.625h-2V8.281a2.346 2.346 0 0 0-2.344-2.344h-1.563a.781.781 0 0 0-.781.782v3.906H.781a.781.781 0 0 0-.781.781v7.813c0 .431.35.781.781.781h14.344a2.35 2.35 0 0 0 2.299-1.884l.937-4.688a2.335 2.335 0 0 0-.486-1.945 2.336 2.336 0 0 0-1.812-.858Zm-14.5 1.563H6.25v6.25H1.562v-6.25Zm14.328 5.621.938-4.687a.779.779 0 0 0-.766-.934H13.28a.781.781 0 0 1-.781-.782V8.281c0-.43-.35-.781-.781-.781h-.781v3.906c0 .432-.35.781-.782.781H7.812v6.25h7.313a.783.783 0 0 0 .766-.628Z",
    fill: "#777"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.844 3.125h.781v.781a.781.781 0 1 0 1.563 0v-.781h.78a.781.781 0 0 0 0-1.563h-.78v-.78a.781.781 0 0 0-1.563 0v.78h-.781a.781.781 0 1 0 0 1.563ZM3.594 3.125h.781v.781a.781.781 0 1 0 1.563 0v-.781h.78a.781.781 0 1 0 0-1.563h-.78v-.78a.781.781 0 1 0-1.563 0v.78h-.781a.781.781 0 1 0 0 1.563ZM19.219 1.563h-.782V.78a.781.781 0 0 0-1.562 0v.781h-.781a.781.781 0 1 0 0 1.563h.781v.781a.781.781 0 1 0 1.563 0v-.781h.78a.781.781 0 0 0 0-1.563Z",
    fill: "#777"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.906,
    cy: 16.094,
    r: 0.781,
    fill: "#777"
  })));
};
export default SvgThumbsUp;